import useFeature from "@casino/legacy/client/hooks/feature/useFeature";
import dynamic from "next/dynamic";

type Props = {
  module: "details" | "home" | "lists" | "gameBanner" | "tournament";
};

const TournamentLists = dynamic(() => import("./modules/TournamentLists"));
const HomeTournaments = dynamic(() => import("./modules/HomeTournaments"), {
  ssr: false,
});
const TournamentDetails = dynamic(() => import("./modules/TournamentDetails"));
const CurrentTournaments = dynamic(() => import("./modules/Tournament"), {
  ssr: false,
});

const Tournaments: FC<Props> = ({ module }) => {
  const isTournamentsEnabled = useFeature("isGameLeaderboardsEnabled");
  if (!isTournamentsEnabled) {
    return null;
  }

  switch (module) {
    case "lists": {
      return <TournamentLists />;
    }
    case "home": {
      return <HomeTournaments />;
    }
    case "tournament": {
      return <CurrentTournaments />;
    }
    default: {
      return <TournamentDetails />;
    }
  }
};

export default Tournaments;
